import type { IdvOpsResponse } from './types';

const API_URL = import.meta.env.VITE_API_URL;

export const getAuthHeaders = (): HeadersInit => ({
  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

export const getIdvOpsUrl = (workerId: string | number): string => `${API_URL}/admin/candidates/${workerId}/idv_ops`;

export const getIdvExcludeUrl = (workerId: string | number): string => `${getIdvOpsUrl(workerId)}/exclude`;

export const getAttemptCountLabel = (count: number): string => `Attempts ${count}`;

export const EMPTY_IDV_OPS: IdvOpsResponse = {
  partner_worker_id: 0,
  bgc_status: '',
  resolution: {
    resolved_attempt_id: null,
    resolved_kind: null,
    resolved_by: null,
    resolved_at: null,
  },
  exclude: {
    excluded: false,
    exclude_auto_withdraw_by: null,
    exclude_auto_withdraw_at: null,
  },
  read_only: false,
  read_only_reason: null,
  actions: {
    mark_as: { allowed: true, reason: null },
    exclude_auto_withdraw: { allowed: true, reason: null },
  },
  empty_attempts_reason: null,
  policy: {
    entered_id_review_at: null,
    copy: '',
    badge: '',
    reason: null,
    system_defaults: {
      reminder_1_days: 10,
      reminder_2_days: 20,
      auto_withdraw_days: 30,
    },
    overrides: {
      reminder_1_days: null,
      reminder_2_days: null,
      auto_withdraw_days: null,
    },
    steps: [],
  },
  attempts: [],
  history: [],
};
